import { Text } from "@chakra-ui/react";
import { Button, Flex, Menu, MenuButton, MenuList, MenuItem, MenuDivider, Tooltip } from '@chakra-ui/react';
import { ChevronDownIcon } from "@chakra-ui/icons";
import StatusBadge from 'components/badge/StatusBadge';
import { formatIndianNumber } from 'utils/getPostMessage';
const STATUS = {
  'active': 'Active',
  'expired': 'Expired'
};

export const subscriptionColumns = ({ teamMembers = [], onAssignSalesPerson } = {}) => [
  {
    Header: "USER NAME",
    accessor: "user_first_name",
    Cell: ({ value, row }) => {
      return (
        <a
          href={`/#/admin/user-usage/?sub_id=${row.original._id}`}
          target="_blank"
          cursor="pointer"
          rel="noopener noreferrer"
          style={{ fontSize: '11px', fontWeight: 600, cursor: 'pointer' }}
        >
          {value}
        </a>
      );
    },
  },
   {
    Header: "PLAN NAME",
    accessor: "plan_name",
  },
    {
    Header: "CATEGORY",
    accessor: "category",
    Cell: ({value})=>(
       <Text>
        {value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()}
      </Text>
    )
  },
  {
    Header: "STATUS",
    accessor: "status",
    Cell: ({ value }) => (
      <Flex align="center" justify={'center'}>
        <Text>
          <StatusBadge status={STATUS[value] || 'Unknown'} />
        </Text>
      </Flex>
    ),
  },
  {
    Header: "START DATE",
    accessor: "start_date",
  },
  {
    Header: "END DATE",
    accessor: "end_date",
  },
   {
    Header: "EMAIL",
    accessor: "user_email",
  },
  {
    Header: "PHONE",
    accessor: "user_phone",
  },
  {
    Header: "METHOD",
    accessor: "created_by",
    Cell: ({ value }) => {
      return (
        <Flex align="center" justify={"center"}>
          <Text>{value || "-"}</Text>
        </Flex>
      );
    },
  },
  {
    Header: "CREATED BY",
    accessor: "admin_data",
    Cell: ({ value, row }) => {
      const adminName = `${value?.first_name} ${value?.last_name}`
      const created_by = row?.values?.created_by === "admin" ? "admin" : "user";
      const label = `${created_by}${value?.first_name ? ` (${adminName})` : ""}`

      return (
        <Flex align="center" justify={"center"}>
          <Text>{label || "-"}</Text>
        </Flex>
      );
    },
  },
  {
    Header: "SALES PERSON",
    accessor: "sales_person_data",
    Cell: ({ value, row }) => {
      const subId = row?.original?._id;
      const currentLabel = value?._id
        ? `${value?.first_name || ''} ${value?.last_name || ''}`.trim() + (value?.role ? ` — ${value.role}` : '')
        : 'Assign';
      return (
        <Flex align="center" justify="center">
          <Menu placement="bottom-end" closeOnSelect>
            <MenuButton
              as={Button}
              size="xs"
              variant={value?._id ? "solid" : "outline"}
              colorScheme={value?._id ? "teal" : "gray"}
              rightIcon={<ChevronDownIcon />}
            >
              {currentLabel || 'Assign'}
            </MenuButton>
            <MenuList maxH="300px" overflowY="auto" zIndex={2000}>
              {value?._id && (
                <>
                  <MenuItem onClick={() => onAssignSalesPerson?.(subId, null)} color="red.500">
                    Unassign
                  </MenuItem>
                  <MenuDivider />
                </>
              )}
              {teamMembers.length === 0 ? (
                <MenuItem isDisabled>No team members</MenuItem>
              ) : (
                teamMembers.map((m) => (
                  <MenuItem
                    key={m._id}
                    onClick={() => onAssignSalesPerson?.(subId, m._id)}
                  >
                    {`${m.first_name || ''} ${m.last_name || ''}`.trim()}
                    {m.role ? ` — ${m.role}` : ''}
                  </MenuItem>
                ))
              )}
            </MenuList>
          </Menu>
        </Flex>
      );
    },
  },
  {
    Header: "PAID AMOUNT",
    accessor: "paid_amount",
    Cell: ({ value }) => (
      <Flex align="center" justify="center">
        <Text>{`₹ ${formatIndianNumber(value || 0)}`}</Text>
      </Flex>
    ),
  },
  {
    Header: "COMMISSION (10%)",
    accessor: "commission",
    Cell: ({ value }) => (
      <Flex align="center" justify="center">
        <Text>{`₹ ${formatIndianNumber(value || 0)}`}</Text>
      </Flex>
    ),
  },
  {
    Header: "COMMENT",
    accessor: "comment",
    Cell: ({ value = "" }) => (
      <Flex align="center" justify="center">
        {value?.length > 20 ? (
          <Tooltip label={value} aria-label="comment">
            <Text>{`${value.slice(0, 20)}...`}</Text>
          </Tooltip>
        ) : (
          <Text>{value || "-"}</Text>
        )}
      </Flex>
    ),
  },
  {
    Header: "COMMENT INFO",
    accessor: "commented_by",
    Cell: ({ value, row }) => {
      const createdStr = row?.original?.commented_at;
      const updatedStr = row?.original?.comment_updated_at;
      if (!value && !createdStr && !updatedStr) return <Text>-</Text>;
      return (
        <Flex direction="column" align="center" justify="center">
          {value && <Text fontWeight="600">{value}</Text>}
          {createdStr && (
            <Text fontSize="0.65rem" color="gray.600">
              Created: {createdStr}
            </Text>
          )}
          {updatedStr && updatedStr !== createdStr && (
            <Text fontSize="0.65rem" color="gray.600">
              Updated: {updatedStr}
            </Text>
          )}
        </Flex>
      );
    },
  },
  {
    Header: "IP ADDRESS",
    accessor: "created_ip",
    Cell: ({ value }) =>
      value ? (
        <a
          href={`https://whatismyipaddress.com/ip/${value}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: "#3182ce", textDecoration: "underline" }}
        >
          {value}
        </a>
      ) : (
        <Text>-</Text>
      ),
  },
];
